import { render } from "./demo.vue?vue&type=template&id=5c27b016&scoped=true"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"

import "./demo.vue?vue&type=style&index=0&id=5c27b016&scoped=true&lang=scss"

import exportComponent from "C:\\proyectos-alliances\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c27b016"]])

export default __exports__